import type { ResourceArticleContentId } from '../../types/resource-article-published';
import { SUMMER_JOBS_DATE_PUBLISHED } from '../seo/summer-jobs-resource-seo';

/**
 * Calendar date the article was first published (YYYY-MM-DD). Used for hub sort, on-page display, and SEO alignment.
 */
export const RESOURCE_ARTICLE_PUBLISHED_ISO_DAY: Record<ResourceArticleContentId, string> = {
  // Older / evergreen
  'cool-tech-english': '2025-12-05',
  'best-job-websites': '2025-11-28',
  'job-market-helsinki-2026': '2026-03-27',
  'job-market-tampere-2026': '2026-03-27',
  'summer-jobs': SUMMER_JOBS_DATE_PUBLISHED.split('T')[0]!,
  'technology-salary-guide-202603': '2026-03-18',
  'technology-salary-guide-202604': '2026-04-02',
  'hidden-job-market-networking-202603': '2026-03-29',
  'highest-salaries-finland': '2026-03-17',
  // March 2026 data / guide drop
  'finland-job-market-march-2026': '2026-03-27',
  'remote-work-finland': '2026-03-27',
  'salary-transparency': '2026-03-27',
  'salary-transparency-law-2026': '2026-03-31',
  'linkedin-finland': '2026-03-27',
  'cv-finnish-employer': '2026-03-27',
  'cv-template-finland': '2026-08-06',
};

export function getResourceArticlePublishedIsoDay(id: ResourceArticleContentId): string {
  return RESOURCE_ARTICLE_PUBLISHED_ISO_DAY[id];
}
